import React, { useState, useEffect } from "react";

export default function Poznamky() {
    const [note, setNote] = useState("");
    const [notes, setNotes] = useState([]);

    // Načítanie poznámok zo servera
    useEffect(() => {
        fetch("http://localhost/new-react-app/public/notes.php")
            .then(res => res.json())
            .then(data => setNotes(data))
            .catch(() => setNotes([]));
    }, []);

    // Pridanie poznámky
    const handleAdd = (e) => {
        e.preventDefault();
        if (!note.trim()) return;
        fetch("http://localhost/new-react-app/public/notes.php", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: `note=${encodeURIComponent(note)}`
        })
            .then(res => res.json())
            .then(data => {
                setNotes(data);
                setNote("");
            });
    };

    return (
        <section className="poznamky-section">
            <h2>Poznámky (To-Do list)</h2>
            <form onSubmit={handleAdd}>
                <input
                    type="text"
                    value={note}
                    onChange={e => setNote(e.target.value)}
                    placeholder="Napíš poznámku..."
                />
                <button type="submit">Pridať</button>
            </form>
            <ul>
                {notes.map((n, i) => (
                    <li key={i}>{n}</li>
                ))}
            </ul>
        </section>
    );
}